import { TYPE_NUMBER } from './input-types';

export const id = 'insuranceFee';
export const apiKey = 'InsuranceFee';
export const type = TYPE_NUMBER;

export const insuranceFee = {
  id,
  apiKey,
  type,
};
